import AuthService from './Services/AuthService'
import CompanyService from './Services/CompanyService'
import HealthUnitService from './Services/HealthUnitService'
import DoctorsService from './Services/DoctorsService'
import StationService from './Services/StationService'
import ScheduleService from './Services/ScheduleUnitService'
import { NetworkInterface } from './Types/NetworkInterface'
import UserService from './Services/UserService'
import DoctorService from './Services/DoctorService'
import CfmService from './Services/CfmService'
import GroupService from './Services/GroupService'
import PermissionService from './Services/PermissionService'
import PositionService from './Services/PositionService'
import ShiftService from './Services/shiftService'
import DsPolicyService from './Services/DsPolicyService'
import DsPaymentPolicyService from './Services/DsPaymentPolicyService'
import FormationService from './Services/FormationService'
import ObservationService from './Services/DsObservationService'
import HandoverInviteService from './Services/HandoverInvites'
import AuthorizationService from './Services/AuthorizationService'
import ConsultingAddressService from './Services/ConsultingAddressService'
import GeocodingService from './Services/GeocodingService'
import DSAttendanceService from './Services/DsAttendanceService'
import NpsDriverService from './Services/NpsDriverService'
import NpsQuestionService from './Services/NpsQuestionService'
import NpsFormService from './Services/NpsFormService'
import NpsFamilyService from './Services/NpsFamilyService'
import NpsFamilySurveyService from './Services/NpsFamilySurveyService'
import NpsAssociationService from './Services/NpsAssociationService'
import NpsEvaluatorService from './Services/NpsEvaluatorService'
import NpsEvaluatorHealthUnitService from './Services/NpsEvaluatorHealthUnitService'
import NpsAnswerService from './Services/NpsAnswerService'
import NpsAnalyticsService from './Services/NpsAnalyticsService'
import NpsConfigService from './Services/NpsConfigService'
import NpsPublicFormService from './Services/NpsPublicFormService'
import NpsInternalEvaluationService from './Services/NpsInternalEvaluationService'
import NpsQuestionCategoryService from './Services/NpsQuestionCategoryService'
import NpsSubmissionService from './Services/NpsSubmissionService'
import NpsAnswerItemService from './Services/NpsAnswerItemService'
import ApprovalFlowService from './Services/ApprovalFlowService'
import WebNotificationService from './Services/WebNotificationService'
import FacialBiometryService from './Services/FacialBiometryService'
import QualificationImportService from './Services/QualificationImportService'
import QualificationTransferService from './Services/QualificationTransferService'
import QualificationDocumentalService from './Services/QualificationDocumentalService'
import PostStationService from './Services/PostStationService'
import DoctorCheckVerificationService from './Services/DoctorCheckVerificationService'
import DoctorCheckEvidenceService from './Services/DoctorCheckEvidenceService'
import CheckAttemptsService from './Services/CheckAttemptsService'
import CheckValidationService from './Services/CheckValidationService'
import HealthUnitPinService from './Services/HealthUnitPinService'
import PlacesService from './Services/PlacesService'
import EffectiveCheckService from './Services/EffectiveCheckService'
import PriorityPaymentsService from './Services/PriorityPaymentsService'
import CoverageResponsibleService from './Services/CoverageResponsibleService'
import SectorService from './Services/SectorService'
import SpecialtyService from './Services/SpecialtyService'
import DashboardSavedViewService from './Services/DashboardSavedViewService'
import VacancyCenterService from './Services/VacancyCenterService'
import DemandService from './Services/DemandService'
import UnitMapService from './Services/UnitMapService'
import AntecipeAffiliateService from './Services/AntecipeAffiliateService'
import ProfessionalDocumentsService from './Services/ProfessionalDocumentsService'
import PreAllocationsService from './Services/PreAllocationsService'
import QualificationEligibilityService from './Services/QualificationEligibilityService'
import AnnouncementService from './Services/AnnouncementService'
import TermService from './Services/TermService'
import AllocationInviteService from './Services/AllocationInviteService'

class Network implements NetworkInterface {
  auth: AuthService
  company: CompanyService
  doctors: DoctorsService
  healthUnit: HealthUnitService
  schedule: ScheduleService
  station: StationService
  user: UserService
  doctor: DoctorService
  cfm: CfmService
  group: GroupService
  permission: PermissionService
  position: PositionService
  observation: ObservationService
  policy: DsPolicyService
  shift: ShiftService
  paymentFormation: FormationService
  dsPaymentPolicy: DsPaymentPolicyService
  handoverInvite: HandoverInviteService
  authorization: AuthorizationService
  consultingAddress: ConsultingAddressService
  geocoding: GeocodingService
  dsAttendance: DSAttendanceService
  npsDriver: NpsDriverService
  npsQuestion: NpsQuestionService
  npsForm: NpsFormService
  npsFamily: NpsFamilyService
  npsFamilySurvey: NpsFamilySurveyService
  npsAssociation: NpsAssociationService
  npsEvaluator: NpsEvaluatorService
  npsEvaluatorHealthUnit: NpsEvaluatorHealthUnitService
  npsAnswer: NpsAnswerService
  npsAnalytics: NpsAnalyticsService
  npsConfig: NpsConfigService
  npsPublicForm: NpsPublicFormService
  npsInternalEvaluation: NpsInternalEvaluationService
  npsQuestionCategory: NpsQuestionCategoryService
  npsSubmission: NpsSubmissionService
  npsAnswerItem: NpsAnswerItemService
  approvalFlow: ApprovalFlowService
  webNotification: WebNotificationService
  facialBiometry: FacialBiometryService
  qualificationImport: QualificationImportService
  qualificationTransferPolicy: QualificationTransferService
  qualificationDocumentalPolicy: QualificationDocumentalService
  postStation: PostStationService
  doctorCheckVerification: DoctorCheckVerificationService
  doctorCheckEvidence: DoctorCheckEvidenceService
  checkAttempts: CheckAttemptsService
  checkValidation: CheckValidationService
  healthUnitPin: HealthUnitPinService
  places: PlacesService
  /** F4 — comando administrativo do horário efetivo (backoffice, F1 §6.2). */
  effectiveCheck: EffectiveCheckService
  /** Fila "Pagamentos prioritários" (À vista + Antecipe). */
  priorityPayments: PriorityPaymentsService
  coverageResponsible: CoverageResponsibleService
  sector: SectorService
  specialty: SpecialtyService
  dashboardSavedView: DashboardSavedViewService
  /** Central de vagas (Onda 2.5a). */
  vacancyCenter: VacancyCenterService
  /** Tela Demanda (Onda 2.2): summary, changes e quadro-meta; Timeline (Onda 2.3). */
  demand: DemandService
  /** Mapa da unidade + links do Modo TV (Onda 2.4). O Modo TV público NÃO entra aqui. */
  unitMap: UnitMapService
  /** Portal do Afiliado Antecipe (contrato B) + "ver como" da equipe BNG. */
  antecipeAffiliate: AntecipeAffiliateService
  /** Revisão de documentos do médico (medical-docs-qualification). */
  professionalDocuments: ProfessionalDocumentsService
  /** Kanban "Demandas urgentes" (pré-alocações). */
  preAllocations: PreAllocationsService
  /** Qualificação exigida por escala + pré-checagem (medical-docs-qualification). */
  qualificationEligibility: QualificationEligibilityService
  announcement: AnnouncementService
  term: TermService
  /** Convite de alocação do escalista (acceptance-terms). */
  allocationInvite: AllocationInviteService
  constructor() {
    this.auth = new AuthService()
    this.company = new CompanyService()
    this.healthUnit = new HealthUnitService()
    this.schedule = new ScheduleService()
    this.station = new StationService()
    this.user = new UserService()
    this.doctors = new DoctorsService()
    this.doctor = new DoctorService()
    this.cfm = new CfmService()
    this.group = new GroupService()
    this.permission = new PermissionService()
    this.position = new PositionService()
    this.policy = new DsPolicyService()
    this.shift = new ShiftService()
    this.paymentFormation = new FormationService()
    this.dsPaymentPolicy = new DsPaymentPolicyService()
    this.observation = new ObservationService()
    this.handoverInvite = new HandoverInviteService()
    this.authorization = new AuthorizationService()
    this.consultingAddress = new ConsultingAddressService()
    this.geocoding = new GeocodingService()
    this.dsAttendance = new DSAttendanceService()
    this.npsDriver = new NpsDriverService()
    this.npsQuestion = new NpsQuestionService()
    this.npsForm = new NpsFormService()
    this.npsFamily = new NpsFamilyService()
    this.npsFamilySurvey = new NpsFamilySurveyService()
    this.npsAssociation = new NpsAssociationService()
    this.npsEvaluator = new NpsEvaluatorService()
    this.npsEvaluatorHealthUnit = new NpsEvaluatorHealthUnitService()
    this.npsAnswer = new NpsAnswerService()
    this.npsAnalytics = new NpsAnalyticsService()
    this.npsConfig = new NpsConfigService()
    this.npsPublicForm = new NpsPublicFormService()
    this.npsInternalEvaluation = new NpsInternalEvaluationService()
    this.npsQuestionCategory = new NpsQuestionCategoryService()
    this.npsSubmission = new NpsSubmissionService()
    this.npsAnswerItem = new NpsAnswerItemService()
    this.approvalFlow = new ApprovalFlowService()
    this.webNotification = new WebNotificationService()
    this.facialBiometry = new FacialBiometryService()
    this.qualificationImport = new QualificationImportService()
    this.qualificationTransferPolicy = new QualificationTransferService()
    this.qualificationDocumentalPolicy = new QualificationDocumentalService()
    this.postStation = new PostStationService()
    this.doctorCheckVerification = new DoctorCheckVerificationService()
    this.doctorCheckEvidence = new DoctorCheckEvidenceService()
    this.checkAttempts = new CheckAttemptsService()
    this.checkValidation = new CheckValidationService()
    this.healthUnitPin = new HealthUnitPinService()
    this.places = new PlacesService()
    this.effectiveCheck = new EffectiveCheckService()
    this.priorityPayments = new PriorityPaymentsService()
    this.coverageResponsible = new CoverageResponsibleService()
    this.sector = new SectorService()
    this.specialty = new SpecialtyService()
    this.dashboardSavedView = new DashboardSavedViewService()
    this.vacancyCenter = new VacancyCenterService()
    this.demand = new DemandService()
    this.unitMap = new UnitMapService()
    this.antecipeAffiliate = new AntecipeAffiliateService()
    this.professionalDocuments = new ProfessionalDocumentsService()
    this.preAllocations = new PreAllocationsService()
    this.qualificationEligibility = new QualificationEligibilityService()
    this.announcement = new AnnouncementService()
    this.term = new TermService()
    this.allocationInvite = new AllocationInviteService()
  }
}

export default new Network() as NetworkInterface
